import Api from 'App/api'

export const getEmergencyContacts = Api.get({
  controller: 'emergency_contacts',
  action: 'list',
})

export const deleteEmergencyContact = Api.post({
  controller: 'emergency_contacts',
  action: 'delete',
})

export const saveEmergencyContact = Api.post({
  controller: 'emergency_contacts',
  action: 'save',
})
